import styled, { css } from 'styled-components';
import { withModifiers } from 'utils/styles';
import { color, typography } from 'styles/settings';
import { isFunction } from 'lodash';

export const ALIGN_MAP = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

const fieldCss = css`
  align-items: center;
  display: flex;
  flex-grow: 1;
  overflow: hidden; // Or flex might break
  padding: 1rem 0;
`;

export const Container = styled.div`
  background-color: transparent;
  margin: 15px auto;
  z-index: 2;
  width: 100%;
`;

export const Table = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 0 10px 0;
  padding: 0;
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  z-index: ${({ zIndex }) => (zIndex ? zIndex : 0)};
`;

// border-top: 2px solid #3f51b5;
export const HeaderField = styled.span`
  color: #464646;
  box-sizing: content-box;
  background-color: rgb(232, 231, 238);
  border-bottom-color: rgb(204, 201, 211);
  display: flex;
  flex-direction: column;
  font-weight: 800;
  font-size: 16px;

  justify-content: ${({ align }) => ALIGN_MAP[align]};
  min-height: 30px;
  ${fieldCss};
  ${withModifiers('tableSearchable')`
    padding-bottom: 2.6rem;
  `};
  ${withModifiers('searchable')`
    padding-bottom: 0.5rem;
  `};
`;
// border-top: 1px solid #ddd;
export const Field = styled.span`
  box-sizing: content-box;
  border-bottom: 1px solid ${color.neutral.grayLight};
  color: #666666;
  ${typography.font.medium};
  font-size: ${typography.size.rg};
  line-height: ${typography.size.ml};
  min-height: 25px;
  ${fieldCss};
  z-index: ${({ zIndex }) => (zIndex ? zIndex : 0)};
  justify-content: ${({ align }) => ALIGN_MAP[align]};
  ${withModifiers('bold')`
    ${typography.font.semiBold};
  `}
  ${withModifiers('upperCase')`
    text-transform: uppercase;
  `}
  
  ${({ onClick, $onRowClick }) => {
    if (isFunction(onClick) || isFunction($onRowClick)) {
      return 'cursor: pointer';
    }
  }}
`;
